<template>
  <div
    class="flex flex-row justify-between gap-3 p-3 rounded-lg w-full border border-1 "
    :class="selected ? 'border-BLACK' : 'border-LIGHTGREY'"
    @click="handleClick"
  >
    <div class="flex flex-row gap-3 items-center">
      <div class="flex flex-col justify-center items-center rounded-full p-1 bg-BLUEGREY w-9 h-9">
        <img :src="imageUrl" class="w-6 h-8 object-contain" />
      </div>
      <p class="text-sm font-semibold text-BLACK">{{ language.name }}</p>
    </div>
    <div class="flex flex-row items-center justify-center">
      <font-awesome-icon v-if="selected" class="black-icon" icon="fa-solid fa-check" />
      
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  language: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emit = defineEmits(['update:selected'])

const imageUrl = new URL(`../assets/icons/${props.language.icon}`, import.meta.url).href

const handleClick = () => {
  emit('update:selected')
}
</script>
